import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';

function defaultSwiperSettings(slidesPerView = 1, speed = 500, autoplay = true, autoHeight = true){
    return {
        modules: [Navigation, Pagination, Autoplay],
        autoplay: autoplay,
        speed: speed,
        slidesPerView: slidesPerView,
        centerInsufficientSlides: true,
        autoHeight: autoHeight,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        a11y: true
    };
}

document.addEventListener("DOMContentLoaded", function () {

    if( document.querySelectorAll('.brand-logo-slider-block') ){
        let sliders = document.querySelectorAll('.brand-logo-slider-block');
        
        sliders.forEach(function(slider){
            
            const developmentsSlider = new Swiper( slider.querySelector('.swiper') , {
                ...defaultSwiperSettings('auto', 330, false, false),
                spaceBetween: 6,
                centeredSlides: false,
                slidesPerView: "auto",
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true,
                    freeMode: true,
                    renderBullet: function(index, className){
                        return '<button aria-label="Go to slide ' + (index + 1 )  + '" class="' + className + '">' + "</button>";
                    }
                },
                navigation: {
                    nextEl: slider.querySelector('.swiper-button-next'),
                    prevEl: slider.querySelector('.swiper-button-prev')
                },
                breakpoints: {
                    300: {
                        slidesPerView: 1,
                    },
                    500: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                        freeMode: false,
                    },
                    1024: {
                        slidesPerView: 4,
                        freeMode: false,
                    },
                    1280: {
                        slidesPerView: 6,
                        freeMode: false,
                    }
                }
            });
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {

    if( document.querySelectorAll('.hero-large-block') ){

        let sliders = document.querySelectorAll('.hero-large-block');
        let playButton = document.getElementById('play');
        let pauseButton = document.getElementById('pause');

        sliders.forEach(function(slider){
            
            const heroSlider = new Swiper( slider.querySelector('.hero-slider.swiper') , {
                ...defaultSwiperSettings(),
                centeredSlides: true,
                autoHeight: true,
                autoplay: {
                    delay: 6000,
                },
                loop: true,
                slidesPerView: 1,
                pagination: {
                    el: slider.querySelector('.swiper-pagination-hero'),
                    clickable: true,
                    freeMode: true,
                    renderBullet: function(index, className){
                        return '<button aria-label="Go to slide ' + (index + 1 )  + '" class="' + className + '">' + "</button>";
                    }
                },
                navigation: {
                    nextEl: slider.querySelector('.next-hero'),
                    prevEl: slider.querySelector('.prev-hero')
                },
            });

            if(playButton && pauseButton) {
            
                playButton.addEventListener('click', function(event){
                    var activeSlide = document.getElementsByClassName('swiper-slide-active');
                    if (activeSlide) {
                        heroSlider.autoplay.start();
                        togglePlayIcon(true, playButton, pauseButton);
                    }
                });
        
                pauseButton.addEventListener('click', function(event){
                    var activeSlide = document.getElementsByClassName('swiper-slide-active');
                    if (activeSlide) {
                        heroSlider.autoplay.stop();
                        togglePlayIcon(false, playButton, pauseButton);
                    }
                });
            }
        });

        function togglePlayIcon( play, playButton, pauseButton ){
            if(play){
                playButton.classList.add('hidden');
                pauseButton.classList.remove('hidden');
            }
            else{
                pauseButton.classList.add('hidden');
                playButton.classList.remove('hidden');
            }
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {

    if( document.body.classList.contains('single-tyre') || document.body.classList.contains('single-products') ){

		//create a new slider instance
        const tyre_slider = new Swiper( document.querySelector('.product-gallery.swiper') , {
			...defaultSwiperSettings(1, 500, false, false),
			centeredSlides: true,
			grabCursor: true,
			wrapperClass: 'gallery-wrapper',
			breakpoints: {
				1280: {
					direction: 'vertical',
				}
			},
		});

		//grab all pagination instances on the page
		let pagination_instances = document.getElementsByClassName('product-gallery-custom-pagination');

		//loop over our pagination instances
		for(let i = 0; i < pagination_instances.length; i++) {

			//create a new pagination instance
			const pagination = new Swiper( pagination_instances[i] , {
				...defaultSwiperSettings(3, 500, false, false),
				centeredSlides: false,
				grabCursor: true,
				width: (70 * 3),
				breakpoints: {
					1280: {
						width: 122,
						height: (132 * 3),
						direction: 'vertical'
					}
				},
				wrapperClass: 'pagination-wrapper',
				allowTouchMove: false,
				navigation: {
					nextEl: document.querySelector('.swiper-button-next'),
					prevEl: document.querySelector('.swiper-button-prev')
				},
			});

			tyre_slider.on('slideChange', function () {
				pagination.slideTo(tyre_slider.activeIndex);
			});

			pagination.on('slideChange', function () {
				tyre_slider.slideTo(pagination.activeIndex);
			});

			pagination.on('click', function (e) {
				pagination.slideTo(e.clickedIndex);
			});
		}
    }
});